import NudosGenericSelect from './NudosGenericSelect';

export default NudosGenericSelect;
